import { render, staticRenderFns } from "./riskModuleFxeye.vue?vue&type=template&id=1173d3b2"
import script from "./riskModuleFxeye.vue?vue&type=script&lang=js"
export * from "./riskModuleFxeye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports